import globals from '@descope-ui/theme-globals';
import { getThemeRefs } from '@descope-ui/common/theme-helpers';
import { ListItemClass } from './component/ListItemClass';

const globalRefs = getThemeRefs(globals);

export const vars = ListItemClass.cssVarList;

const listItem = {
  [vars.backgroundColor]: globalRefs.colors.surface.main,
  [vars.verticalPadding]: globalRefs.spacing.lg,
  [vars.horizontalPadding]: globalRefs.spacing.lg,
  [vars.gap]: globalRefs.spacing.md,
  [vars.borderStyle]: 'solid',
  [vars.borderWidth]: globalRefs.border.xs,
  [vars.borderColor]: globalRefs.colors.surface.main,
  [vars.borderRadius]: globalRefs.radius.sm,
  [vars.cursor]: 'pointer',
  [vars.alignItems]: 'center',
  [vars.flexDirection]: 'row',
  [vars.transition]: 'border-color 0.2s, background-color 0.2s',

  variant: {
    tile: {
      [vars.alignItems]: 'flex-start',
      [vars.flexDirection]: 'column',
      [vars.borderColor]: globalRefs.colors.surface.light,
    },
  },

  _hover: {
    [vars.backgroundColor]: globalRefs.colors.surface.highlight,
  },

  _active: {
    [vars.backgroundColor]: globalRefs.colors.surface.main,
    [vars.borderColor]: globalRefs.colors.primary.light,
    [vars.outline]: `1px solid ${globalRefs.colors.primary.light}`,
  },
};

export default listItem;
